import { useGhostPosts } from '../../hooks/useGhostPosts'
import { ProjList, formatDate, type ProjListItem } from '../ProjList/ProjList'
import SectionHeader from '../SectionHeader/SectionHeader.tsx'

const ROW_BASE =
	'grid grid-cols-[auto_1fr] md:grid-cols-[80px_1fr_240px_64px] gap-4 md:gap-8 px-7 py-8 border-b-2 border-ink last:border-b-0 items-center ' +
	'hover:bg-hazard hover:pl-10 transition-[padding,background] duration-150 focus-ring'

export function WritingSection() {
	const { posts, loading, error } = useGhostPosts(3)

	const showPosts = !loading && !error && posts.length > 0

	const items: ProjListItem[] = showPosts
		? posts.map((post) => ({
				id: post.id,
				title: post.title,
				excerpt: post.excerpt || undefined,
				meta: formatDate(post.published_at),
				href: post.url || `https://blog.luizcavalieri.dev/${post.slug}`,
				external: true,
			}))
		: []

	const fallback = (
		<a
			href="https://blog.luizcavalieri.dev"
			target="_blank"
			rel="noopener noreferrer"
			className={ROW_BASE}
		>
			<span className="font-display-cond text-4xl font-black leading-none tracking-[-0.02em] text-ink">
				→
			</span>
			<span className="font-display font-extrabold uppercase text-[28px] leading-[1.1] text-ink">
				View all posts at{' '}
				<em className="font-serif font-medium normal-case italic">blog.luizcavalieri.dev</em>
				<span className="block font-serif font-medium normal-case italic text-[15px] text-ink-dim mt-1.5 leading-[1.45]">
					Long-form notes on the things this site keeps short.
				</span>
			</span>
			<span className="font-mono text-[11px] uppercase text-ink-2 font-medium">External ↗</span>
			<span className="font-display-cond text-[32px] font-black text-right text-ink">→</span>
		</a>
	)

	return (
		<section className="bg-paper-2 px-6 py-16 border-b-4 border-ink">
			<SectionHeader
				number="03"
				variant="ink"
				titlePrimary="Writing"
				titleSecondary="notes from the desk."
				subtitle="Thoughts on engineering leadership, software architecture, AI in publishing, AI Engineering and building good teams."
				metaLines={['SECTION 03', 'BLOG · ESSAYS', 'ONGOING']}
			/>

			<ProjList items={items} fallback={fallback} />
		</section>
	)
}
